// extracted by mini-css-extract-plugin
export default {"bc":"BCrumb_bc__7pnp+","option":"BCrumb_option__ibITL","active":"BCrumb_active__wrDqz"};